import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _ from 'lodash';
import MediaList from './MediaList.jsx';

const mapStateToProps = (state, {metaInfo, mediaType, dataSource}) => {
  const recentPosts = state.dataSources[dataSource];

  const mediaItems = _(recentPosts).map(({0: recentPost}) => {
    if (!recentPost) return;

    const id = recentPost.tags[mediaType][0];
    const meta = _.find(metaInfo, { id });
    return {
      id,
      images: meta.images,
      recentPost: recentPost,
      heading: meta.name,
    };
  }).compact().value();

  return {
    mediaItems,
    sportParam: state.routeParams.sports,
  };
};

const MediaListContainer = ({linkTemplate, mediaItems, sportParam, showMoreText}) =>
  <MediaList mediaItems={mediaItems}
             sportParam={sportParam}
             linkTemplate={linkTemplate}
             showMoreText={showMoreText} />;

export default compose(connect(mapStateToProps))(MediaListContainer);



// WEBPACK FOOTER //
// ./src/component/MediaPages/MediaListContainer.jsx